export default "__VITE_ASSET__DESWGOyr__"